import React, {Component} from 'react';
import Moment from 'react-moment';

import { AuthUserContext, withAuthorization } from '../Session';
import * as ROLES from '../../constants/roles';

import PasswordChangeForm from '../PasswordChange';
import AccountDetailsChangeForm from '../AccountDetailsChange';
import { Container, Image } from 'semantic-ui-react';

const dateToFormat = new Date(); 

const AccountPage = () => (
  <AuthUserContext.Consumer>
    {authUser => (
      <Container>
        <hr/>
        <div class="ui inverted fluid segment">
         <Image src='\Images\bch_logo_small.png' size='small' floated='right' />
          <Moment format="ddd D MMM YYYY, hh:mm:ss a" date={dateToFormat} />
          <h1>Welcome {authUser.username}</h1>
          <div class="customFontSmall">Email: {authUser.email}</div>
          <div class="customFontSmall">Contact Number: {authUser.contactNumber}</div>

          {!!authUser.isNewUser === false && !!authUser.roles[ROLES.USER] && (
          <div class="customFontSmall">Role: Store Associate</div>
          )}

          {!!authUser.isNewUser === false && !!authUser.roles[ROLES.ADMIN] && (
          <div class="customFontSmall">Level: Admin</div>
          )}

          {!!authUser.isNewUser === true && (
          <div class="customFontSmall">Role: Store Associate (please reset your password)</div>
          )}
          <p></p>
        </div>
        <AccountDetailsChangeForm />
        <PasswordChangeForm />
      </Container>
    )}
  </AuthUserContext.Consumer>
);

const condition = authUser => !!authUser;
 
export default withAuthorization(condition)(AccountPage);

